module.exports = __webpack_public_path__ + "img/gpt-ios-step-3.f84cd349.png";